namespace advisorop.components.identity {

    class SetupAccountFormController {
        
        $router;
        laddaProgress = false;
        public setupAccountModel: domains.identity.ISetupAccountModel;

        settingUpAccount = false;
        accountSetupSuccess = false;

        constructor(private identityService: services.IdentityService) {

            this.setupAccountModel = new domains.identity.SetupAccountModel();
            this.setupAccountModel.password = "";
            this.setupAccountModel.confirmPassword = "";
        }

        //login method
        setupAccount(): void {
            
            var r = this.$router;

            this.settingUpAccount = true;

            this.identityService.setupAccount(this.setupAccountModel)
                .then(response => {
                    this.accountSetupSuccess = true;
                    toastr.info("You have successfully setup your account, please sign in to continue.");
                    setTimeout(() => {
                        this.settingUpAccount = false;
                        r.parent.navigate(["Login"]);
                    }, 2000);
                    
                }, err => {
                    toastr.error("Token invalid or expired, please try again." + err.status + ":" + err.data);
                    this.settingUpAccount = false;
                });
        };

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.setupAccountModel.userId = next.params.userId;
            this.setupAccountModel.code = next.params.code;
        }
    }
    
    class SetupAccountForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: '<'
            };
            this.controller = ["identityService", SetupAccountFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/setup-account-form.html';
        }

    }
    angular.module(Constants.APP).component("setupAccountForm", new SetupAccountForm());
}